/* eslint-disable no-param-reassign, max-params, max-lines */

import { SURFACES } from "../misc/constants";

const initialState = {};

const checkoutModule = {
  namespaced: true,

  state() {
    return { ...initialState };
  },

  getters: {
    hasInvalidDimensions: (state, getters, rootState, rootGetters) => {
      const checkSurfaceArtwork = surface => {
        const artwork = rootGetters[`artwork_${surface}/serializedArtwork`];
        if (!artwork) return false;

        const maxSizes = rootGetters[`surface_${surface}/maxInchSizes`];
        const width = rootGetters[`surface_${surface}/convertPxToInches`](artwork.width);
        const height = rootGetters[`surface_${surface}/convertPxToInches`](artwork.height);

        if (Number(width) < 1 || Number(height) < 1) return true;
        return (
          Number(width) > Number(maxSizes.maxWidth) || Number(height) > Number(maxSizes.maxHeight)
        );
      };

      return checkSurfaceArtwork("front") || checkSurfaceArtwork("back");
    },
    checkoutPayload: (state, getters, rootState, rootGetters) => {
      const placements = [];
      const frontArtwork = rootGetters["artwork_front/serializedArtwork"];
      if (frontArtwork) {
        placements.push({
          ...frontArtwork,
          width: rootGetters["surface_front/convertPxToInches"](frontArtwork.width),
          height: rootGetters["surface_front/convertPxToInches"](frontArtwork.height),
          position: rootGetters["surface_front/surfaceLabel"],
          custom_neck_distances: rootGetters["surface_front/serializedNeckLines"](
            frontArtwork.height
          ),
          preview: rootGetters["surface_front/getPreview"] || ""
        });
      }

      const backArtwork = rootGetters["artwork_back/serializedArtwork"];
      if (backArtwork) {
        placements.push({
          ...backArtwork,
          width: rootGetters["surface_back/convertPxToInches"](backArtwork.width),
          height: rootGetters["surface_back/convertPxToInches"](backArtwork.height),
          position: rootGetters["surface_back/surfaceLabel"],
          custom_neck_distances: rootGetters["surface_back/serializedNeckLines"](
            backArtwork.height
          ),
          preview: rootGetters["surface_back/getPreview"] || ""
        });
      }

      return placements;
    }
  },

  mutations: {},

  actions: {
    async resetPayload({ dispatch, rootGetters, commit }) {
      if (rootGetters["artwork_front/artworkExists"]) {
        dispatch("artwork_front/removeArtwork", null, { root: true });
        dispatch("surface_front/clearNeckLines", null, { root: true });
        commit("surface_front/setSurfaceLabel", SURFACES.FRONT, { root: true });
      }
      if (rootGetters["artwork_back/artworkExists"]) {
        dispatch("artwork_back/removeArtwork", null, { root: true });
        dispatch("artwork_back/clearNeckLines", null, { root: true });
        commit("surface_back/setSurfaceLabel", SURFACES.BACK, { root: true });
      }
    }
  }
};

export default checkoutModule;
